<template>
  <div>
    <div class="clearfix"><b-form-group
      id="fieldset-status"
      class="float-right"
      label-cols="3"
      label="Status:"
      label-for="input-status"
    ><b-form-select id="input-status" class="ml-2" style="width: auto" v-model="showArchived" :options="[{value: 0, text: 'Active'},{value: 1, text: 'Archived'}]"></b-form-select></b-form-group></div>

    <!-- TABLE LIST (used when viewing archived entries) -->
    <v-server-table
      v-if="useServerTable"
      class="bg-light p-2 mt-3"
      name="dataTableHappeningNow"
      :columns="tableColumns"
      :url="tableUrl"
      :options="tableOptions"
      :useVuex="true"
      :theme="theme"
      id="table-happening-now"
      ref="table-happening-now"
      :preserveState="preserveState"
    >
      <template slot="dateStart" slot-scope="props">
        {{ props.row.dateStart ? $moment(props.row.dateStart).format('MM/DD/YY') : '' }}
      </template>
      <div slot="actions" slot-scope="props" class="text-center">
        <b-button-group>
          <b-btn size="sm" variant="warning" title="Edit post" :to="'/website-local/happening-now/form/' + props.row.id">Edit</b-btn>
          <b-btn size="sm" variant="success" title="Read more" :href="'//' + sitePublicDomain + '/' + currentBusiness.uriName + '/happening-now/' + props.row.slug" target="_blank">Read More</b-btn>
          <b-btn v-if="!showArchived" size="sm" variant="warning" title="Archive post" @click="setArchivedStatus(props.row.id, true)">Archive</b-btn>
          <b-btn v-else size="sm" variant="warning" title="Unarchive post" @click="setArchivedStatus(props.row.id, false)">Unarchive</b-btn>
          <b-btn v-if="showArchived" size="sm" variant="danger" title="Delete post" @click="postDelete(props.row.id)">Delete</b-btn>
        </b-button-group>
      </div>
    </v-server-table>

    <!-- CARD LIST -->
    <b-card-group v-if="!useServerTable" columns>
      <template v-for="(post, index) in content">
      <b-card
        v-if="post.archived===compareArchived"
        no-body
        class="cursor-pointer mt-3"
        :key="index"
        img-alt="Image"
        img-top
      >
          <b-card-img v-if="post && post.options && post.options.featuredImage" :src="post.options.featuredImage.src"></b-card-img>
          <b-card-body>
            <b-card-title>{{ post.title }}</b-card-title>
            <b-card-text>
              {{ post.summary }}
            </b-card-text>
          </b-card-body>
          <div slot="footer" class="clearfix">
            <small class="text-muted float-left">Posted: {{ $moment(post.dateStart).format('MM/DD/YY') }}</small>
            <span class="float-right">
              <small><router-link class="text-warning" :to="'/website-local/happening-now/form/' + post.id">edit</router-link>
              | <a class="text-success" :href="'//' + sitePublicDomain + '/' + currentBusiness.uriName+'/happening-now/' + post.slug" target="_blank">Read More</a>
              <span v-if="!showArchived"> | <a class="text-warning" href="#" @click.prevent="setArchivedStatus(post.id, true)">Archive</a></span>
              <span v-else> | <a class="text-warning" href="#" @click.prevent="setArchivedStatus(post.id, false)">Unarchive</a></span>
              <span v-if="showArchived"> | <a class="text-danger" href="#" @click.prevent="postDelete(post.id)">Delete</a></span>
              </small></span>
          </div>
      </b-card>
      </template>
    </b-card-group>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { HTTP } from '@/services/http-common'
import { ServerTable } from 'vue-tables-2-premium'

Vue.use(ServerTable)

const DEFAULT_PER_PAGE = 30

export default {
  name: 'HappeningNow',
  data () {
    return {
      showArchived: 0,
      preserveState: true,
      theme: 'bootstrap4',
      tableColumns: ['id', 'title', 'summary', 'dateStart', 'actions'],
      tableOptions: {
        perPage: DEFAULT_PER_PAGE,
        perPageValues: [30, 60, 90, 250, 500],
        async requestFunction (data) {
          return await HTTP.get(this.url, {
            params: data
          }).catch(function (e) {
            this.dispatch('error', e)
          }.bind(this))
        },
        requestAdapter (data) {
          let query = {
            page: data.page ? data.page : '1',
            itemsPerPage: data.limit ? data.limit : DEFAULT_PER_PAGE
          }
          if (data.query !== '') {
            query.search_filter = data.query
          }
          if (data.orderBy) {
            let param = 'order[' + data.orderBy + ']'
            query[param] = data.ascending ? 'asc' : 'desc'
          } else {
            query['order[dateStart]'] = 'desc'
          }
          return query
        },
        responseAdapter ({ data }) {
          return {
            data: data['hydra:member'] || [],
            count: data['hydra:totalItems'] || 0
          }
        },
        headings: {
          id: 'ID',
          title: 'Title',
          summary: 'Summary',
          dateStart: 'Posted Date',
          actions: 'Actions'
        },
        sortable: ['id', 'title', 'dateStart'],
        sortIcon: { base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'content'
    ]),
    compareArchived () {
      return this.showArchived ? true : false
    },
    useServerTable () {
      return !!this.showArchived
    },
    tableUrl () {
      const params = {
        type: 'happening_post',
        archived: this.showArchived
      }
      if (this.currentBusiness && this.currentBusiness.id) {
        params.business = this.currentBusiness.id
      }
      const query = Object.keys(params).map(key => key + '=' + encodeURIComponent(params[key])).join('&')
      return '/contents.jsonld?' + query
    }
  },
  methods: {
    ...mapActions([
      'getContent',
      'putContent',
      'deleteContent',
      'resetContent'
    ]),
    doGetContent () {
      if (this.useServerTable) {
        this.resetContent()
        if (this.$refs['table-happening-now']) {
          this.$refs['table-happening-now'].refresh()
        }
      } else {
        this.getContent({
          business: this.currentBusiness.id,
          type: 'happening_post',
          archived: this.showArchived,
          'order[date_start]': 'desc'
        })
      }
    },
    async setArchivedStatus (id, archive = true) {
      if (confirm(archive ? 'ARCHIVE THE POST?' : 'UNARCHIVE THE POST AND MAKE IT ACTIVE?')) {
        await this.putContent({
          id: id,
          archived: archive
        })
        this.doGetContent()
      }
    },
    async postDelete (id) {
      if (confirm(
`DELETE THE POST?
      
:: THIS CANNOT BE UNDONE! ::`
      )) {
        await this.deleteContent(id)
        this.doGetContent()
      }
    }
  },
  watch: {
    showArchived () {
      this.doGetContent()
    }
  },
  mounted () {
    this.doGetContent()
  },
  beforeDestroy () {
    this.resetContent()
  }
}
</script>
